exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".elcard[data-v-6ed21b3d]{position:relative;min-height:600px}.elcardzz[data-v-6ed21b3d]{position:absolute;top:58px;left:0;right:0;bottom:0}.formscont[data-v-6ed21b3d]{min-height:600px}.formitem[data-v-6ed21b3d]{border-radius:3px}.formitem2[data-v-6ed21b3d],.formitem[data-v-6ed21b3d]{position:relative;padding:3px;overflow:hidden;box-sizing:border-box}.formitem2[data-v-6ed21b3d]{border-radius:3px;border:1px dashed #3a88ed;cursor:move}.formitem2[data-v-6ed21b3d]:hover{border:1px dashed red;transition:.5s}.formitemzz[data-v-6ed21b3d]{position:absolute;top:0;left:0;right:0;bottom:0}.hxdiv[data-v-6ed21b3d]{width:100%;height:2px;background:red;border-radius:2px}.icons1[data-v-6ed21b3d]{position:absolute;top:0;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ed21b3d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/plugin/forms.vue
// module id = 40
// module chunks = 0